import { Product } from '@thro-types/leihbar';

import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const cartItemValidationSchema = (t, product: Product) => ({
  startTime: yup
    .date()
    .required(t(translations.validation.required()))
    .typeError(t(translations.validation.required()))
    .label(t(translations.common.start())),
  endTime: yup
    .date()
    .required(t(translations.validation.required()))
    .typeError(t(translations.validation.required()))
    .label(t(translations.common.end())),
  amount: yup
    .number()
    .test('Enabled greater than 0', 'When Amount enabled then greater than 0', function () {
      if (product.isAmountPossible) return this.parent.amount >= 1;
      return true;
    }),
  options: yup.array().of(yup.object().shape({ id: yup.number(), image: yup.string() })),
  comment: yup.string()
});

export const useAddToCartInitialValues = () => {
  return {
    startTime: null,
    endTime: null,
    options: [],
    comment: '',
    amount: 1
  };
};
